module.exports = __webpack_public_path__ + "static/media/primera_caracteristica.e1fa46d5.png";